import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Tooltip from '@piconetworks/pkg-tooltip';
import Form from '@piconetworks/pkg-form';
import styles from './scss/ChooseNewsletter.module.scss.js';

var _excluded = ["className", "disabled", "isSingleColumn", "newsletter", "previewMode", "showIcon", "input", "meta", "noTooltip"];
var NewsletterCheckbox = function NewsletterCheckbox(_ref) {
  var _cx;
  var className = _ref.className,
    disabled = _ref.disabled,
    _ref$isSingleColumn = _ref.isSingleColumn,
    isSingleColumn = _ref$isSingleColumn === void 0 ? false : _ref$isSingleColumn,
    newsletter = _ref.newsletter,
    previewMode = _ref.previewMode,
    showIcon = _ref.showIcon,
    input = _ref.input,
    meta = _ref.meta,
    noTooltip = _ref.noTooltip,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var FieldEl = /*#__PURE__*/React.createElement("div", {
    className: styles.field
  }, /*#__PURE__*/React.createElement(Form.Checkbox, _extends({
    text: newsletter === null || newsletter === void 0 ? void 0 : newsletter.label,
    description: newsletter === null || newsletter === void 0 ? void 0 : newsletter.description,
    type: "checkbox",
    disabled: disabled,
    className: className,
    customTitleClass: styles.checkboxTitle,
    customDescriptionClass: styles.checkboxDesc,
    customContentClass: styles.checkboxContent,
    outerClassName: styles.outerClassName,
    icon: showIcon ? process.env.S3_BUCKET + "/landing_pages/img/lock_icon.svg" : undefined,
    input: Object.assign({}, input, previewMode && {
      readOnly: true,
      checked: newsletter === null || newsletter === void 0 ? void 0 : newsletter.checked
    }),
    meta: Object.assign({}, meta)
  }, props)), previewMode && /*#__PURE__*/React.createElement("div", {
    className: styles.blockOverlay
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.chooseNewsletterItem, (_cx = {}, _cx[styles.disabled] = disabled, _cx[styles.singleColumn] = isSingleColumn, _cx))
  }, disabled && !noTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    className: styles.tooltip,
    content: "Paid membership required.",
    theme: null,
    placement: "top-start"
  }, FieldEl) : FieldEl);
};
NewsletterCheckbox.defaultProps = {
  input: {},
  meta: {},
  name: 'newsletters',
  previewMode: false,
  showIcon: false
};
NewsletterCheckbox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  input: PropTypes.object,
  isSingleColumn: PropTypes.bool,
  meta: PropTypes.object,
  name: PropTypes.string.isRequired,
  newsletter: PropTypes.shape({
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    value: PropTypes.string
  }).isRequired,
  previewMode: PropTypes.bool,
  showIcon: PropTypes.bool,
  noTooltip: PropTypes.bool
};
var NewsletterCheckbox$1 = NewsletterCheckbox;

export { NewsletterCheckbox$1 as default };
//# sourceMappingURL=NewsletterCheckbox.js.map
